import { numberClamp } from './numberClamp';
import { dateClamp } from './dateClamp';
import { addMonths, differenceInCalendarMonths, eachMonthOfInterval, subMonths } from 'date-fns';

export function getMonths(date, options = {}) {
	const { minDate, maxDate, numberOfMonths } = options;

	/**
	 * We respect the numberOfMonths param even when the difference between
	 * minDate and maxDate are less than numberOfMonths. In this case we
	 * show the minDate + n months.
	 */
	if (differenceInCalendarMonths(maxDate, minDate) < numberOfMonths) {
		return eachMonthOfInterval({
			start: minDate,
			end: addMonths(minDate, numberOfMonths - 1),
		});
	}

	let clampedDate = monthClamp(date);

	let diff = differenceInCalendarMonths(maxDate, clampedDate);

	let endPadding = numberClamp(diff, 0, numberOfMonths - 1);
	let startPadding = numberOfMonths - 1 - endPadding;

	function monthClamp(date) {
		return dateClamp(date, minDate, maxDate);
	}

	return eachMonthOfInterval({
		end: monthClamp(addMonths(clampedDate, endPadding)),
		start: monthClamp(subMonths(clampedDate, startPadding)),
	});
}
